// @flow

import { useDispatch } from 'react-redux';

import { useTranslator } from '@gandi/translate';

import { useFeatureFlag } from 'src/hooks/useFeatureFlag';

import { accountChoiceSubmit } from './accountChoiceSubmit';

export function useAccountChoiceSubmit(): () => Promise<void> {
  const dispatch = useDispatch();
  const translator = useTranslator();

  const displayNewAccountChoice = useFeatureFlag('FF_SHOP_ACCOUNT_CHOICE');

  return () =>
    dispatch(accountChoiceSubmit({ translator, displayNewAccountChoice }));
}
